import { PricingService } from "../../lookup/pricing/PricingService";
import { OrdersTableMode } from "../OrdersTableMode";
import { BasePricingService } from "../../lookup/pricing/impl/BasePricingService";
import { DealtPricingService } from "../../lookup/pricing/impl/DealtPricingService";
import * as CubiqTS from "../../../cubiq-model-multi-asset";
import { ICcyPairLookupService } from "../../lookup/model/ICcyPairLookupService";

export class NdfTrackingFwdPtsHelper {
  constructor(
    protected ccyPairLookup: ICcyPairLookupService,
    protected myBasePricingService: BasePricingService,
    protected myDealtPricingService: DealtPricingService,
  ) {}

  getValue(params: any): string {
    let pricingService: PricingService;
    switch (params.context.mode) {
      case OrdersTableMode.DEALT:
      case OrdersTableMode.NDF_DEALT:
        pricingService = this.myDealtPricingService;
        break;
      case OrdersTableMode.NDF_BASE:
      case OrdersTableMode.BASE:
        pricingService = this.myBasePricingService;
        break;
    }
    let pair: CubiqTS.CurrencyPairImpl = this.ccyPairLookup.getCcyPair(
      params.data.baseCode,
      params.data.nonBaseCode,
    );

    // Inverted spot orders in spot tracking will return 0 instead of empty string in dealt mode
    if (
      params.data &&
      pricingService.isSpotOrder(params.data) &&
      params.context.mode == OrdersTableMode.DEALT &&
      params.data.isInvertedOrderFg
    ) {
      return "";
    }

    if (
      pricingService &&
      pair &&
      pair.ndfEnabledFg &&
      (CubiqTS.Product.FWD === params.data.product ||
        CubiqTS.Product.NDF === params.data.product ||
        CubiqTS.Product.SPT === params.data.product)
    ) {
      return params.context.mode == OrdersTableMode.NDF_BASE ||
        params.context.mode == OrdersTableMode.NDF_DEALT
        ? pricingService.getFwdPtsNdfTrackingFormattedDecs(params.data)
        : pricingService.getFwdPtsFormattedDecs(params.data);
    } else if (
      pricingService &&
      (CubiqTS.Product.FWD === params.data.product ||
        CubiqTS.Product.NDF === params.data.product) &&
      !pricingService.isSpotOrder(params.data)
    ) {
      return pricingService.getFwdPtsFormattedDecs(params.data);
    }
  }

  getInvertValue(params: any): string {
    let pricingService: PricingService = this.myBasePricingService;

    let pair: CubiqTS.CurrencyPairImpl = this.ccyPairLookup.getCcyPair(
      params.data.nonBaseCode,
      params.data.baseCode,
    );
    if (
      pricingService &&
      pair &&
      pair.ndfEnabledFg &&
      (CubiqTS.Product.FWD === params.data.product ||
        CubiqTS.Product.NDF === params.data.product ||
        CubiqTS.Product.SPT === params.data.product)
    ) {
      return params.context.mode == OrdersTableMode.NDF_BASE ||
        params.context.mode == OrdersTableMode.NDF_DEALT
        ? pricingService.getInvertFwdPtsNdfTrackingFormattedDecs(params.data)
        : pricingService.getInvertFwdPtsFormattedDecs(params.data);
    } else if (
      pricingService &&
      (CubiqTS.Product.FWD === params.data.product ||
        CubiqTS.Product.NDF === params.data.product) &&
      !pricingService.isSpotOrder(params.data)
    ) {
      return pricingService.getInvertFwdPtsFormattedDecs(params.data);
    }
  }
}
